var map = {
	"./aparna_rishita.md": 680,
	"./ashutosh.md": 681,
	"./debeshee_kranthi.md": 682,
	"./deep_abhishek.md": 683,
	"./dheeraj_karthik.md": 684,
	"./prantik.md": 685,
	"./preethi.md": 686,
	"./shriram.md": 687,
	"./vartika.md": 688
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 679;